import type { ReactNode, RefObject } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface HelpPanelProps {
  isOpen: boolean;
  onClose: () => void;
  panelRef: RefObject<HTMLDivElement>;
  children: ReactNode;
}

export default function HelpPanel({
  isOpen,
  onClose,
  panelRef,
  children,
}: HelpPanelProps) {
  return (
    <section
      id="help-widget-panel"
      ref={panelRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby="help-widget-title"
      aria-hidden={!isOpen}
      tabIndex={-1}
      className={cn(
        "fixed bottom-24 right-4 z-40 flex w-[min(92vw,26rem)] max-h-[78vh] flex-col overflow-hidden rounded-2xl border border-border/70 bg-background/95 shadow-2xl shadow-black/10 backdrop-blur transition-all duration-200 ease-out sm:bottom-20",
        isOpen
          ? "pointer-events-auto translate-y-0 opacity-100"
          : "pointer-events-none translate-y-3 opacity-0"
      )}
    >
      <header className="shrink-0 border-b border-border/60">
        <div className="flex items-center justify-between px-4 py-2.5">
          <h2 id="help-widget-title" className="text-sm font-semibold">
            Apuri
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-7 w-7 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            aria-label="Sulje apuri"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </header>

      <div className="flex flex-1 flex-col overflow-hidden px-3 py-2">
        {children}
      </div>
    </section>
  );
}
